import React from "react";

import { css } from "@emotion/core";

import { Field } from "@zapier/design-system";

import { CurrencyDropdown } from "@zapier/checkout/esm/components";
import { useApolloInjection } from "@zapier/checkout/esm/contexts/ApolloInjection";
import { Currency } from "@zapier/currency";

const containerStyles = css`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;

  @media (max-width: 375px) {
    display: block;
    }
  }
`;

type Props = {
  onSelectCurrency: (currency: Currency) => void;
  selectedCurrency: Currency;
};

export const ChangePlanCurrencyDropdown = ({
  onSelectCurrency,
  selectedCurrency,
}: Props) => {
  const { useQuery } = useApolloInjection();

  return (
    <div css={containerStyles}>
      <Field
        label="Payment currency"
        renderInput={() => (
          <CurrencyDropdown
            onSelectCurrency={onSelectCurrency}
            selectedCurrency={selectedCurrency}
            useQuery={useQuery}
          />
        )}
      />
    </div>
  );
};
